/* eslint-disable */
import {
  Flex,
  Form,
  Input,
  Modal,
  Select,
  Table,
  Tag,
  DatePicker,
  message,
  Tooltip,
  Badge,
  Dropdown,
  List,
  Button,
  Radio,
  Spin,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import { Typography, InputNumber } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import moment from "moment";
import createSorter from "@/components/createSorter";
import {
  DollarOutlined,
  MenuOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  HistoryOutlined,
  ClusterOutlined,
  DotChartOutlined,
  BlockOutlined,
  MailOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { dataTo12Fn } from "@/utils/date.js";
const { RangePicker } = DatePicker;
const MainTable = forwardRef(({ statusFilter, ...props }, ref) => {
  const [tableList, setTableList] = useState([]); // 表格数据
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [selectionType] = useState("checkbox");

  const [moToPoForm] = Form.useForm();
  const [tableoading, setTableLoading] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const initialTableHead = {
    status: null,
    prop: null,
    workType: null,
    propUnit: null,
    address: null,
    city: null,
    job: null,
    remark: null,
    requestBy: null,
    createBy: null,
    requestNo: null,
    vendorName: null,
    sCreateTime: null,
    sCompletionDate: null,
    eCreateTime: null,
    eCompletionDate: null,
    requestByName: null,
    payType: null,
    documentOnlyReason: null,
    ids: null,
    groupSupervisor: null,
    orderField: null,
    orderType: null,
    sActualCompletionDate: null,
    eActualCompletionDate: null,
  };
  const [tableHead, setTableHead] = useState(initialTableHead);
  const [reviewMaterialsModal, setReviewMaterialsModal] = useState(false);
  const [reviewMaterialsList, setReviewMaterialsList] = useState([]);
  const [approvalState, setApprovalState] = useState({
    id: null,
    reviewStatus: "2",
    rejectReason: "",
  });
  const [approvalModal, setApprovalModal] = useState(false);
  const [openMoToPo, setOpenMoToPo] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [clockList, setClockList] = useState([]);
  const [closkModal, setCloskModal] = useState(false);
  const [pickerDates, setPickerDates] = useState(null);
  const [PredictedDates, setPredictedDates] = useState(null);
  const [clockListLoading, setClockListLoading] = useState(false);
  const [reviewMaterialsLoading, setReviewMaterialsLoading] = useState(false);
  // 映射表单 ，转化配置
  const fieldMap = {
    jobs: "job", // jobs -> job
  };
  const handleOk = (dates, confirm, startKey, endKey) => {
    if (dates && dates.length === 2) {
      const startDate = dates[0].format("MM/DD/YYYY");
      const endDate = dates[1].format("MM/DD/YYYY");
      const startTime = dates[0].valueOf();
      const endTime = dates[1].valueOf();

      handleApiCall(
        startDate,
        endDate,
        startTime,
        endTime,
        confirm,
        startKey,
        endKey,
      );
    } else {
      return;
    }
  };

  // 通用的 API 调用
  const handleApiCall = async (
    startDate,
    endDate,
    startTime,
    endTime,
    confirm,
    startKey,
    endKey,
  ) => {
    console.log("Fetching data for:", startDate, endDate);
    setTableHead((prev) => {
      const updatedTableHead = {
        ...prev,
        [startKey]: startTime,
        [endKey]: endTime,
      };
      console.log("Updated tableHead:", updatedTableHead);
      fetchData(1, pagination.pageSize, updatedTableHead);
      return updatedTableHead;
    });
    if (confirm) {
      confirm(); //  关闭下拉
    }
  };
  // 通用 Reset
  const handleReset = (setDates, startKey, endKey, clearFilters) => {
    clearFilters?.();
    setDates([]);
    setTableHead((prev) => {
      const updatedTableHead = {
        ...prev,
        [startKey]: "",
        [endKey]: "",
      };
      fetchData(1, pagination.pageSize, updatedTableHead);
      return updatedTableHead;
    });
  };

  // 列表定义：
  const createInputHandler = (fieldName) => (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHead = { ...prev, [fieldName]: inputValue };
        fetchData(1, 25, updatedTableHead);
        return updatedTableHead;
      });
    }
  };

  const createSelectHandler = (fieldName) => (value) => {
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, [fieldName]: value };
      fetchData(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };

  const createSearchableColumn = (
    title,
    dataIndex,
    width = 100,
    extraProps = {},
  ) => ({
    title: (
      <div>
        <div>{title}</div>
        <div>
          <Input
            placeholder={`Search ${title}`}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={createInputHandler(dataIndex)}
          />
        </div>
      </div>
    ),
    dataIndex,
    key: dataIndex,
    width,
    sorter: createSorter(dataIndex),
    className: "custom-sort-header",
    align: "center",
    ...extraProps,
    render:
      extraProps.render ||
      ((text) => (
        <Tooltip title={text} classNames="my-tooltip">
          <div
            className="text-clamp"
            style={{ whiteSpace: "normal", width: `${width}px` }}
          >
            {text}
          </div>
        </Tooltip>
      )),
  });

  // 创建带有选择器的列
  const createSelectableColumn = (
    title,
    dataIndex,
    options,
    width = 100,
    extraProps = {},
  ) => ({
    title: (
      <div>
        <div>{title}</div>
        <div>
          <Select
            value={tableHead[dataIndex]}
            defaultValue="All"
            placeholder={`Select ${title}`}
            style={{ width }}
            onClick={(e) => e.stopPropagation()}
            onChange={createSelectHandler(dataIndex)}
            options={options}
          />
        </div>
      </div>
    ),
    dataIndex,
    key: dataIndex,
    width,
    sorter: createSorter(dataIndex),
    className: "custom-sort-header",
    align: "center",
    ...extraProps,
  });
  const createJobsColumn = (width = 200, extraProps = {}) => ({
    ...createSearchableColumn("Job Type", "job", width, {
      ...extraProps,
      render: (text, record) => (
        <Flex gap="4px 0" wrap>
          {record.jobs?.map((item, idx) => (
            <Tooltip key={`job-${idx}`} title={item}>
              <Tag
                color="blue"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: `${width - 20}px`,
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    }),
  });

  const createRequestedByColumn = (width = 100, extraProps = {}) => ({
    ...createSelectableColumn(
      "Requested By",
      "requestByName",
      [
        { value: "", label: "All" },
        { value: "1", label: "Tenant" },
        { value: "2", label: "Manager" },
      ],
      width,
      extraProps,
    ),
  });

  // 定义列，包括输入框
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "index",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("ReviewMaterials") ||
          commonFn.btnAuthorityFlag("InvoiceJobHistory") ||
          commonFn.btnAuthorityFlag("LinkProp") ||
          commonFn.btnAuthorityFlag("LinkProp-Unit") ||
          commonFn.btnAuthorityFlag("LinkProp-Unit-Tenant") ||
          commonFn.btnAuthorityFlag("MOToPO")) && (
          <Badge count={record.messageCount} offset={[6, -6]} size={"small"}>
            <Dropdown
              menu={{
                items: [
                  commonFn.btnAuthorityFlag("ReviewMaterials") && {
                    key: "ReviewMaterials",
                    icon: (
                      <EditOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Review Materials",
                  },
                  commonFn.btnAuthorityFlag("InvoiceJobHistory") && {
                    key: "InvoiceJobHistory",
                    icon: (
                      <HistoryOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Invoice Job History",
                  },
                  commonFn.btnAuthorityFlag("LinkProp") && {
                    key: "Prop",
                    icon: (
                      <ClusterOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Link Prop",
                  },
                  commonFn.btnAuthorityFlag("LinkProp-Unit") && {
                    key: "Unit",
                    icon: (
                      <DotChartOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Link Prop-Unit",
                  },
                  commonFn.btnAuthorityFlag("LinkProp-Unit-Tenant") && {
                    key: "Tenant",
                    icon: (
                      <BlockOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Link Prop-Unit-Tenant",
                  },
                  commonFn.btnAuthorityFlag("MOToPO") && {
                    key: "MOToPO",
                    icon: (
                      <DollarOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "MO To PO",
                    //  disabled: record.workType === 2,
                  },
                ],
                onClick: (e) => badgeFn(record, e),
              }}
              trigger={["click"]}
            >
              <MenuOutlined
                style={{
                  cursor: "pointer",
                  fontSize: "16px",
                  color: "#0e78a9",
                }}
              />
            </Dropdown>
          </Badge>
        ),
    },
    createSearchableColumn("Request No", "requestNo", 180),
    {
      title: (text, record, index) => (
        <div>
          <div>Status</div>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      align: "center",
      hidden: false,
      width: 100,
      sorter: createSorter("status"),
      className: "custom-sort-header",
      render: (text, record, index) => {
        let statusText = "";
        let tagColor = "";
        if (text == "Ready To Pay") {
          statusText = "Ready To Pay";
          tagColor = "#00a65a";
        } else if (text == "Document Only") {
          statusText = "Document Only";
          tagColor = "#3c8dbc";
        }
        return (
          <a onClick={(e) => showModalOpen(record)}>
            <Tag color={tagColor}>{statusText}</Tag>
          </a>
        );
      },
    },
    {
      title: "Completed Date",
      dataIndex: "actualCompletionDate",
      key: "actualCompletionDate",
      width: 130,
      sorter: true,
      align: "center",
      hidden: statusFilter !== "Ready To Pay",
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={PredictedDates}
            onChange={(dates) => {
              setPredictedDates(dates);
              handleOk(
                dates,
                confirm,
                "sActualCompletionDate",
                "eActualCompletionDate",
              );
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setPredictedDates,
                "sActualCompletionDate",
                "eActualCompletionDate",
                clearFilters,
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },

    createSearchableColumn("invoice Count ", "invoiceCount", 80),
    {
      title: "Created Time",
      dataIndex: "createTime",
      key: "createTime",
      width: 130,
      align: "center",
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={pickerDates}
            onChange={(dates) => {
              setPickerDates(dates);
              handleOk(dates, confirm, "sCreateTime", "eCreateTime");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setPickerDates,
                "sCreateTime",
                "eCreateTime",
                clearFilters,
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => moment(text).format("MM/DD/YYYY HH:mm"),
    },
    createJobsColumn(150, { hidden: false }),
    createSearchableColumn("Remark", "remark", 100),
    createSelectableColumn(
      "Material",
      "isMaterials",
      [
        { value: "", label: "All" },
        { value: "1", label: "Yes" },
        { value: "2", label: "No" },
      ],
      90,
      {
        hidden: statusFilter !== "Ready To Pay",
        render: (text) => {
          const isMaterials = {
            1: "Yes",
            2: "No",
          };
          return text ? isMaterials[text] || " " : " ";
        },
      },
    ),

    createSearchableColumn("Doc.Only Reason", "documentOnlyReason", 120, {
      hidden: statusFilter !== "Document Only",
    }),
    createSelectableColumn(
      "Vendor Type",
      "workType",
      [
        { value: "", label: "All" },
        { value: "1", label: "Maint.Worker" },
        { value: "2", label: "Contractor" },
        { value: "3", label: "Gardener" },
      ],
      100,
      {
        hidden: statusFilter !== "Ready To Pay",
        render: (text) => {
          const workTypeMap = {
            1: "Maint.Worker",
            2: "Contractor",
            3: "Gardener",
          };
          return text ? workTypeMap[text] || " " : " ";
        },
      },
    ),
    createSearchableColumn("Vendor Name", "vendorName", 100, {
      hidden: statusFilter !== "Ready To Pay",
    }),
    {
      title: "Predicted Date",
      dataIndex: "completionDate",
      key: "completionDate",
      width: 100,
      align: "center",
      sorter: true,
      hidden: statusFilter !== "Ready To Pay",
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={PredictedDates}
            onChange={(dates) => {
              setPredictedDates(dates);
              handleOk(dates, confirm, "sCompletionDate", "eCompletionDate");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setPredictedDates,
                "sCompletionDate",
                "eCompletionDate",
                clearFilters,
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },
    createSearchableColumn("Unit Address", "address", 140),
    createSearchableColumn("City", "city", 100),

    createSearchableColumn("Group Supervisor", "groupSupervisor", 100),
    createRequestedByColumn(100, { hidden: false }),
    createSearchableColumn("Create By", "createByName", 100),
  ];
  const [columns, setColumns] = useState(() => {
    return initColumns.map((col) => {
      const column = { ...col };
      if (col.dataIndex === "#") {
        column.render = (text, record, index) =>
          (pagination.current - 1) * pagination.pageSize + index + 1;
      }
      return column;
    });
  });
  const badgeFn = (record, item) => {
    const fnMatch = {
      ReviewMaterials: reviewMaterialsModalFn,
      InvoiceJobHistory: invoiceJobHistoryFn,
      Prop: (record) => {
        console.log(record);
        showOpen({
          propId: record.propId,
          type: "Prop",
        });
      },

      Unit: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          type: "Unit",
        }),

      Tenant: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          tenantId: record.tenantId,
          type: "Tenant",
        }),
      MOToPO: (record) => {
        setCurrentRecord(record);
        setOpenMoToPo(true);
      },
    };

    if (fnMatch[item.key]) {
      fnMatch[item.key](record);
    }
  };
  // const invoiceJobHistoryFn = async ({ id }) => {
  //   const response = await http.get(`${api.getClockList}?maintenanceId=${id}`);
  //   if (response.code === "1") {
  //     setClockList(response.data || []);
  //     setCloskModal(true);
  //   }
  // };

  // const reviewMaterialsModalFn = async ({ id }) => {
  //   const response = await http.get(
  //     `${api.showMaterialsByMaintenanceId}?maintenanceId=${id}`
  //   );
  //   if (response.code === "1") {
  //     setReviewMaterialsList(response.data || []);
  //     setReviewMaterialsModal(true);
  //   }
  // };

  const invoiceJobHistoryFn = async ({ id }) => {
    setCloskModal(true);
    setClockListLoading(true);
    setClockList([]);
    try {
      const response = await http.get(
        `${api.getClockList}?maintenanceId=${id}`,
      );
      if (response.code === "1") {
        setClockList(response.data || []);
      } else {
        message.warning(response.msg || "Failed to load history.");
      }
    } catch (err) {
      message.error("Failed to load history.");
    } finally {
      setClockListLoading(false);
    }
  };
  const reviewMaterialsModalFn = async ({ id }) => {
    setReviewMaterialsModal(true);
    setReviewMaterialsLoading(true);
    setReviewMaterialsList([]);
    try {
      const response = await http.get(
        `${api.showMaterialsByMaintenanceId}?maintenanceId=${id}`,
      );
      if (response.code === "1") {
        setReviewMaterialsList(response.data || []);
      } else {
        message.warning(response.msg || "Failed to load materials.");
      }
    } catch (err) {
      message.error("Failed to load materials.");
    } finally {
      setReviewMaterialsLoading(false);
    }
  };
  const approvalFn = (item) => {
    setApprovalState({
      ...approvalState,
      id: item.id,
      maintenanceId: item.maintenanceId,
    });
    setApprovalModal(true);
  };

  const approvalSubmitFn = async () => {
    const response = await http.post(`${api.reviewMaterials}`, approvalState);
    if (response.code === "1") {
      reviewMaterialsModalFn({ id: approvalState.maintenanceId });
    } else {
      Modal.confirm({
        title: null,
        // icon: <ExclamationCircleOutlined />,
        content: response.msg,
        footer: null,
        closable: true,
        maskClosable: true,
      });
    }
    approvalModalCancel();
  };

  const approvalModalCancel = () => {
    setApprovalModal(false);
    setApprovalState({
      id: null,
      reviewStatus: "2",
      rejectReason: "",
    });
  };

  //列表
  const fetchData = async (current, pageSize, tableHead = {}) => {
    try {
      setTableLoading(true);
      const hash = window.location.hash;
      const queryStart = hash.indexOf("?");

      let ids = null;
      let statusFilterFromUrl = null;

      if (queryStart !== -1) {
        const queryString = hash.substring(queryStart + 1);
        const searchParams = new URLSearchParams(queryString);
        ids = searchParams.get("ids");
        statusFilterFromUrl = searchParams.get("statusFilter");
      }

      const params = {
        page: current || pagination.current,
        count: pageSize || pagination.pageSize,
        type: statusFilterFromUrl || statusFilter,
        ...tableHead,
        ...(ids ? { ids } : {}),
      };

      console.log("Request params:", params);
      const response = await http.get(api.MaintenanceShowHistory, { params });
      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.id,
      }));

      setTableList(dataWithKey);
      setFilteredData(dataWithKey);
      setPagination((prev) => ({
        ...prev,
        current: params.page,
        total: response.data.total,
        pageSize: params.count,
      }));
    } catch (err) {
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

  // 处理分页变化
  const handleTableChange = (newPagination, filters, sorter) => {
    // 需要传递当前的 tableHead 搜索条件 \搜索
    let orderField = "";
    let orderType = "";
    if (sorter && sorter.field) {
      orderField = fieldMap[sorter.field] || sorter.field;
      orderType = sorter.order === "ascend" ? "asc" : "desc";
    }
    fetchData(newPagination.current, newPagination.pageSize, {
      ...tableHead,
      orderField,
      orderType,
    });
  };

  //复选框
  const rowSelection = {
    // 通过 getCheckboxProps 控制第一行不显示复选框
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, // 隐藏复选框
      disabled:
        record.status !== "Pending" ||
        (record.status === "Quoted" && materials_confirm_type === 2),
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      //选中
      console.log(selectedRowKeys);
      console.log(selectedRows);
      setSelectedList(selectedRows);
      props.deleteNum(selectedRows); //调用父组件方法
    },
  };

  //details跳转
  const showModalOpen = (record) => {
    if (!record || record.id == null) return;

    const u = new URL(window.location.href);
    const route = "/JobRequests/Maintenance/Details";
    const qs = new URLSearchParams({ id: String(record.id) }).toString();
    u.hash = `${route}?${qs}`;

    window.open(u.toString(), "_blank", "noopener,noreferrer");
  };

  const showOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    // const route = "/JobRequests/Maintenance/PUTTable";
    const route = "/JobRequests/MaintenanceHistory/PUTTableHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    // 保持原有方法
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {},
    getSearchValues: () => ({
      ...tableHead,
    }),
    newListFun: () => {
      setTableHead(initialTableHead);
      fetchData(pagination.current, pagination.pageSize, tableHead);
      setRefreshKey((prev) => prev + 1);
    },
    // 添加导出需要的方法
    getQueryParams: () => ({
      ...tableHeadRef.current,
      type: statusFilter,
      page: pagination.current,
      count: pagination.pageSize,
    }),
  }));
  // 初始化数据
  const tableHeadRef = useRef(tableHead);

  // motopo modal 操作
  const handleSubmit = async () => {
    setBtnLoading(true);
    try {
      const values = await moToPoForm.validateFields();
      const params = {
        maintenanceId: currentRecord?.id,
        quotedAmount: values.quotedAmount,
      };
      let res;
      try {
        res = await http.get(api.getAddContractorPayAndChangeMWT, {
          params,
          validateStatus: () => true,
        });
      } catch (e) {
        res = e?.response?.data;
      }
      if (res?.code === "1") {
        message.success("Submit success.");
        setOpenMoToPo(false);
        moToPoForm.resetFields();
        fetchData(pagination.current, pagination.pageSize, tableHead);
      } else {
        message.warning(res?.msg || "Unknown error");
      }
    } finally {
      setBtnLoading(false);
    }
  };

  useEffect(() => {
    tableHeadRef.current = tableHead;
  }, [tableHead]);
  useEffect(() => {
    const controller = new AbortController();
    const loadData = async () => {
      await fetchData(pagination.current, pagination.pageSize, tableHead, {
        signal: controller.signal,
      });
    };
    loadData();
    return () => {
      controller.abort();
    };
  }, [statusFilter, location.hash, pagination.current, pagination.pageSize]);

  return (
    <div>
      <Table
        rowClassName="table-row-gradient"
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        loading={tableoading}
        columns={initColumns.filter((col) => !col.hidden)}
        dataSource={[...filteredData]}
        pagination={{
          showQuickJumper: true,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showTotal: (total) => {
            return `Total: ${total} items`;
          },
          showSizeChanger: true,
        }}
        rowKey="id"
        key={refreshKey}
        onChange={handleTableChange}
        scroll={{ x: scrollX, y: "calc(100vh - 320px)" }}
        locale={{
          emptyText: (
            <div style={{ padding: "40px 0", color: "#999" }}>No Data</div>
          ),
        }}
      />
      <Modal
        width="30%"
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <FileTextOutlined style={{ marginRight: "8px" }} />
            Review Materials
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        className="reviewMaterialsModal"
        footer={
          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              onClick={() => setReviewMaterialsModal(false)}
            >
              Close
            </Button>
          </div>
        }
        open={reviewMaterialsModal}
        onCancel={(e) => setReviewMaterialsModal(false)}
      >
        <Spin spinning={reviewMaterialsLoading}>
          <List
            header={null}
            footer={null}
            split={true}
            className="review-materials-list"
            dataSource={reviewMaterialsList}
            renderItem={(item) => (
              <List.Item className="review-materials-item">
                <div className="RM-top">
                  <div className="RM-left">
                    <div>Pick-Up Location:</div>
                    <Input.TextArea
                      autoSize
                      disabled={true}
                      value={item.storeName}
                    />
                    <div>MaterialsRemark:</div>
                    <Input.TextArea
                      autoSize
                      disabled={true}
                      value={item.materialsRemark}
                    />
                  </div>
                  <div className="RM-right">
                    <div className="RM-icon">
                      {item.reviewStatus === 2 && (
                        <CheckOutlined style={{ color: "#18bc37" }} />
                      )}
                      {item.reviewStatus === 3 && (
                        <CloseOutlined style={{ color: "#ff0000" }} />
                      )}
                    </div>
                    <div>
                      {item.reviewStatus === 1 ? (
                        <div className="ApprovalBtn">
                          <div>Waiting For Approval</div>
                          <div className="RM-btn">
                            <Button
                              type="primary"
                              onClick={() => approvalFn(item)}
                            >
                              Approval
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div>{item.reviewByName}</div>
                          <div>{dataTo12Fn(item.reviewTime, 2)}</div>
                          <div>{dataTo12Fn(item.reviewTime, 3)}</div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </Spin>
      </Modal>
      <Modal
        width="30%"
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            Do You Agree
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        footer={null}
        open={approvalModal}
        onCancel={approvalModalCancel}
      >
        <Radio.Group
          value={approvalState.reviewStatus}
          options={[
            {
              value: "2",
              label: "agree",
            },
            {
              value: "3",
              label: "refuse",
            },
          ]}
          onChange={(e) =>
            setApprovalState({ ...approvalState, reviewStatus: e.target.value })
          }
        />
        {approvalState.reviewStatus === "3" && (
          <div
            style={{ display: "flex", alignItems: "center", marginTop: "12px" }}
          >
            <span>Reason：</span>
            <Input.TextArea
              autoSize
              value={approvalState.rejectReason}
              onChange={(e) =>
                setApprovalState({
                  ...approvalState,
                  rejectReason: e.target.value,
                })
              }
              placeholder="input rejectReason"
            />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "12px",
          }}
        >
          <Button type="primary" onClick={() => approvalSubmitFn()}>
            Submit
          </Button>
        </div>
      </Modal>
      <Modal
        width="30%"
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            Invoice Job History
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        footer={
          <div style={{ textAlign: "center" }}>
            <Button type="primary" onClick={() => setCloskModal(false)}>
              Close
            </Button>
          </div>
        }
        open={closkModal}
        onCancel={() => setCloskModal(false)}
      >
        <Spin spinning={clockListLoading}>
          <div
            className="IJH-list"
            style={{ minHeight: clockListLoading ? 100 : "auto" }}
          >
            {clockList.length
              ? clockList.map((item) => (
                  <div key={item.id} className="IJH-item">
                    <span>Time: </span>
                    <span className="IJH-time">
                      {dataTo12Fn(item.clockTime)}
                    </span>
                  </div>
                ))
              : !clockListLoading && <div className="IJH-noData">no data</div>}
          </div>
        </Spin>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <DollarOutlined style={{ marginRight: "8px" }} />
            MO TO PO
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openMoToPo}
        maskClosable={false}
        okText="Submit"
        onCancel={() => {
          setOpenMoToPo(false);
          moToPoForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
        styles={{
          body: {
            height: "180px",
            padding: "24px",
            display: "flex",
            alignItems: "center",
          },
          footer: {
            textAlign: "center",
          },
        }}
      >
        <Form
          form={moToPoForm}
          justify="space-between"
          align="flex-start"
          style={{ width: "100%" }}
        >
          <Form.Item
            name="quotedAmount"
            label="Amount"
            rules={[{ required: true, message: "Please input amount" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Amount"
              min={0}
              precision={2}
              formatter={(value) =>
                value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
});
export default MainTable;
